import { NavLink } from "react-router-dom";
import { GraduationCap, Zap, Home, MessageCircle, CalendarClock, Phone, PlugZap, BookOpen, BarChart3, Settings } from "lucide-react";
import { DentiumLogo } from "@/components/DentiumLogo";
import { useClinic } from "@/hooks/useClinic";

const NAV = [
  { to: "/", label: "Inicio", icon: Home, end: true, testid: "nav-inicio" },
  { to: "/conversaciones", label: "Conversaciones", icon: MessageCircle, testid: "nav-conversaciones" },
  { to: "/entrenar", label: "Entrenar asistente", icon: GraduationCap, testid: "nav-entrenar" },
  { to: "/citas", label: "Citas", icon: CalendarClock, testid: "nav-citas" },
  { to: "/llamadas", label: "Llamadas", icon: Phone, testid: "nav-llamadas" },
  { to: "/metricas", label: "Métricas", icon: BarChart3, testid: "nav-metricas" },
  { to: "/conectar", label: "Conectar cuenta", icon: PlugZap, testid: "nav-conectar" },
  { to: "/configuracion", label: "Configuración", icon: Settings, testid: "nav-configuracion", adminOnly: true },
  { to: "/respuestas-automaticas", label: "Respuestas automáticas", icon: Zap, testid: "nav-respuestas-automaticas", adminOnly: true },
  { to: "/conocimiento", label: "Base de conocimientos", icon: BookOpen, testid: "nav-conocimiento" },
];

export const Sidebar = ({ isAdmin }) => {
  const clinic = useClinic();
  return (
    <aside
      data-testid="app-sidebar"
      className="w-[72px] md:w-64 shrink-0 h-screen bg-[#0A0A0A] flex flex-col border-r border-black"
    >
      <div className="h-16 flex items-center justify-center md:justify-start md:px-6 border-b border-white/10">
        <DentiumLogo dark size="sm" />
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-2 md:px-3 space-y-1">
        {NAV.filter((item) => isAdmin || !item.adminOnly).map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors justify-center md:justify-start ${
                  isActive
                    ? "bg-white text-[#0A0A0A]"
                    : "text-white/70 hover:bg-white/10 hover:text-white"
                }`
              }
              title={item.label}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="hidden md:inline">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="hidden md:block px-6 py-4 border-t border-white/10 text-[11px] text-white/40 leading-snug">
        <span data-testid="sidebar-clinic-info">{[clinic.name, clinic.city].filter(Boolean).join(" · ")}</span>
        <br />Atención 24/7 en WhatsApp e Instagram
      </div>
    </aside>
  );
};
